let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kDGaT")).then(() => parcelRequire('9NKdT'));